import React, { useEffect, useState } from "react";
import axios from "axios";
import { Spin } from "antd";
import useStore from "../../store/useStore";
import message from "../../components/message";

const Verify = () => {
  const clearStore = useStore((state) => state.clearStore);

  const [messageText, setMessageText] = useState("");
  const [verifying, setVerifying] = useState(true);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const urlString = window.location.href; //window.location.href
        const url = new URL(urlString);
        const user = url.searchParams.get("user");

        const { data } = await axios.post(`/auth/verify`, { linkId: user });

        setMessageText(data.message_mn ?? data.message_en ?? "");

        if (data.statusCode === 200) {
          message(data.result.payload ?? "Амжилттай", true);
          clearStore();
          window.location.href = "/";
        }
      } catch (e) {
        console.error("User Email Verification: ", e);
      } finally {
        setVerifying(false);
      }
    };

    void verifyEmail();
  }, [clearStore]);

  // http://merchant.pickpack.mn/verify?user=oY9HX70sdNXcjG2cUvdqo
  // oY9HX70sdNXcjG2cUvdqo

  return (
    <div style={{ textAlign: "center" }}>
      <h2>Баталгаажуулалт</h2>

      <Spin spinning={verifying}>
        <h3>{messageText}</h3>
      </Spin>
    </div>
  );
};

export default Verify;
